const headerHeight = 70;

export { headerHeight };
